<template>
    <v-container  v-if="item">
    <v-row class="mb-3" no-gutters justify="space-between">
      <h2 class="text-h4">{{ $t('accessRights.title') }}</h2>
      <action-button
        id="pfid1618820354" 
        v-if="isOwner"
        @click="addDialog = true"
        icon="$add"
        :tooltip="$t('accessRights.addEditor.title')"
        color="primary"
        fab
        small
        dark
      />
    </v-row>
    <v-data-table  id="pfid1618820364" :headers="headers" :items="item.accessRights" :loading="loading">
        <template v-slot:item.role="{item: i}">
            {{ getRole(i.role) }}
        </template>
        <template v-slot:item.actions="{item : i}">
            <action-button class="pfcl1618820391" v-if="i.role == 'EDITOR' && isOwner" icon="$remove" :tooltip="$t('accessRights.revokeAccess')" @click="showRemoveDialog(i)"></action-button>
        </template>
    </v-data-table>
    <v-dialog max-width="1000px" v-model="addDialog">
        <access-token-generator endpoint="companies" @close="addDialog=false" />
    </v-dialog>
    <v-dialog max-width="500px" v-model="removeDialog">
        <v-card v-if="userToRemove">
            <v-card-title><v-icon left color="warning">$warn</v-icon> {{$t('accessRights.removeEditor.title')}}</v-card-title>
            <v-card-text>
                {{$t('accessRights.removeEditor.text', { name: userToRemove.email }) }} 
                <v-switch v-model="cascade" :label="$t('accessRights.removeEditor.cascade')" />
            </v-card-text>
            <v-card-actions>
                <v-btn text color="warning" @click="removeEditor" :loading="loading"><v-icon left>$remove</v-icon>{{$t('dialog.remove')}}</v-btn>
                <v-btn text @click="removeDialog = false"><v-icon left>$close</v-icon>{{$t('dialog.cancel')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    </v-container>
    <v-skeleton-loader type="table" v-else />
</template>
<script>

import { mapState } from 'vuex';
import AccessTokenGenerator from '@/components/AccessTokenGenerator'

export default {
    name: 'Access',
    components: {AccessTokenGenerator},
    data() {
        return {
            addDialog: false,
            removeDialog: false,
            userToRemove: null,
            cascade: true,
            loading: false,
            newEditors: [],
            headers: [
                { text: this.$t('common.emailAddress'), value: 'email' },
                { text: this.$t('common.role'), value: 'role'},
                { text: this.$t('common.actions'), value: 'actions' }
            ]
        }
    },
    computed: {
        isOwner() {
            return this.$store.getters['auth/isOwner']({ item: this.item })
        },
        ...mapState('companies', ['item']),
    },
    methods: {
        getRole(r) {
            var t = this.$t(`accessRights.${r.toLowerCase()}`);
            return t;
        },
        showRemoveDialog(user) {
            this.userToRemove = user;
            this.removeDialog = true;
        },
        removeEditor() {
            this.loading = true;
            //var newEditors = [...this.item.editors].splice(this.item.editors.indexOf(this.userToRemove.cognitoID),1);
            //this.$store.dispatch('domains/update', { fields: { editors: newEditors }}).then( () => {this.loading = false; this.userToRemove = null; } );
            this.$store.dispatch('auth/revokeAccess', { companyID: this.item.id, cognitoID: this.userToRemove.cognitoID, cascade: this.cascade }).then((result) => {
                this.loading = false;
                this.removeDialog = false;
                if(result) {
                    this.$store.dispatch('ui/notify', { text: this.$t('accessRights.revoked')});
                    this.$store.dispatch('companies/get', { id: this.item.id });
                } else {
                this.$store.dispatch('ui/notify', { text: this.$t('accessRights.revokeError'), error: true });
                }
            });
        }
    }
}
</script>